<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="66" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="平台" v-if="false">
          <ElSelect v-model="platform" clearable placeholder="全部">
            <ElOption :value="1" label="Android"></ElOption>
            <ElOption :value="2" label="iOS"></ElOption>
          </ElSelect>
        </ElFormItem>

        <ElFormItem label="素材游戏">
          <ElSelect v-model="gameId" @change="sendEvent" clearable filterable placeholder="全部">
            <el-option v-for="item in GAMES" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </ElSelect>
        </ElFormItem>

        <ElFormItem label="素材游戏组">
          <ElSelect v-model="gameGroupId" @change="sendEvent" clearable filterable placeholder="全部">
            <el-option v-for="item in GAME_GROUPS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </ElSelect>
        </ElFormItem>

        <ElFormItem label="媒体">
          <ElSelect v-model="media" style="width: 140px" clearable @change="sendEvent">
            <ElOption :value="10" label="巨量引擎"></ElOption>
            <ElOption :value="16" label="腾讯"></ElOption>
            <ElOption :value="6" label="超级汇川"></ElOption>
            <ElOption :value="45" label="百度信息流"></ElOption>
            <ElOption :value="32" label="磁力引擎"></ElOption>
          </ElSelect>
        </ElFormItem>
        <ElFormItem label="素材标签">
          <ElSelect v-model="labelId" placeholder="全部" style="width: 140px" filterable clearable @change="sendEvent">
            <el-option v-for="item in SYS_TAGS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </ElSelect>
        </ElFormItem>
        <ElFormItem>
          <!-- <top-datepick v-model="dateType" @on-select="sendEvent" /> -->
          <div class="date-selector-wrapper">
            <el-radio-group class="date-type-radio" v-model="dateType" @change="handlerDateType">
              <el-radio-button :label="DATE_TYPE.DAY">日</el-radio-button>
              <el-radio-button :label="DATE_TYPE.WEEK">周</el-radio-button>
              <el-radio-button :label="DATE_TYPE.MONTH">月</el-radio-button>
            </el-radio-group>

            <div class="date-picker-wrapper">
              <ElDatePicker
                v-show="dateType === DATE_TYPE.DAY"
                v-model="date.day"
                :picker-options="{ disabledDate }"
                type="date"
                placeholder="请选择"
                style="width: 100px"
                @change="onDateRangeChange"
              />

              <div>
                <el-date-picker
                  v-if="dateType === DATE_TYPE.WEEK"
                  v-model="date.week"
                  type="week"
                  prefix-icon="a"
                  format="yyyy 第 WW 周"
                  style="width: 120px"
                  @change="onDateRangeChange"
                  :picker-options="{ firstDayOfWeek: 1 }"
                  placeholder="选择周"
                >
                </el-date-picker>
              </div>
              <div>
                <el-date-picker
                  v-if="dateType === DATE_TYPE.MONTH"
                  v-model="date.month"
                  type="month"
                  style="width: 120px"
                  :picker-options="monthOptions"
                  @change="onDateRangeChange"
                  placeholder="选择月"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { isArray } from '@/common/js/utils'

import { getPtomGroupGames } from '@/api/material.model'
import { getSysTag, adGames } from '@/api/common.model'

import { initPageData, GAMES, SYS_TAGS, GAME_GROUPS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([SYS_TAGS, GAME_GROUPS, GAMES])

const DATE_TYPE = {
  DAY: 1,
  WEEK: 2,
  MONTH: 3
}
export default {
  name: 'rankFilter',
  computed: {
    ...PAGE_REQUIRED_OPTS
  },

  data() {
    return {
      DATE_TYPE,
      dateType: 1,
      media: '',
      gameGroupId: '', // 游戏组id
      gameId: '',
      labelId: '',
      platform: '',
      labelData: [],
      gameData: [],
      groupData: [],
      date: {
        day: moment().format('YYYY-MM-DD'),
        week: moment().format('YYYY-MM-DD'),
        month: moment().format('YYYY-MM')
      },
      monthOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  methods: {
    handlerDateType() {
      const { day, week, month } = this.date
      if (day || week || month) {
        this.sendEvent()
      }
    },
    onDateRangeChange() {
      this.sendEvent()
    },
    disabledDate(date) {
      return date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24
    },

    sendEvent() {
      let beginTime = ''
      const { day, week, month } = this.date
      switch (this.dateType) {
        case DATE_TYPE.DAY:
          if (day) {
            beginTime = moment(day).format('YYYY-MM-DD')
          }
          break
        case DATE_TYPE.WEEK:
          if (week) {
            beginTime = moment(week).startOf('week').format('YYYY-MM-DD')
          }
          break
        case DATE_TYPE.MONTH:
          if (month) {
            beginTime = moment(month).format('YYYY-MM-01')
          }
          break
        default:
          break
      }

      this.$emit('on-change', {
        dateType: this.dateType,
        beginTime,
        mediaId: this.media || -1,
        gameId: this.gameId || -1,
        gameGroupId: this.gameGroupId || -1,
        labelId: this.labelId || -1,
        platform: this.platform > 0 ? this.platform : 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.date-selector-wrapper {
  display: flex;
  align-items: center;
}
.date-picker-wrapper {
  margin-left: 5px;
}
</style>
<style lang="scss">
.week-range {
  // 当周今天和之后的日期样式置灰
  .empty-date {
    div {
      background-color: #f5f7fa;
      cursor: not-allowed;
      color: #c0c4cc;
    }
    span {
      color: #c0c4cc !important;
      font-weight: normal !important;
    }
  }
}
</style>
